import React from 'react';
import ThankYouContractForm from '../../../../view/ThankYouContractForm';

const Ty = (props)=>{
    let customProps = {
        filename: (props.location.state) ? props.location.state.filename : "",
        fullname: (props.location.state) ? props.location.state.fullname : "",
        destinationEmail: (props.location.state) ? props.location.state.destinationEmail : "",
        dn: (props.location.state) ? props.location.state.dn : "",
        fallback: "/contracts/business/promissory-note/4",
        details: (props.location.state) ? props.location.state.details : ""
    }
    return (
        <ThankYouContractForm {...customProps} />
    )
}

export default Ty;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/promissory-note/Ty.js